enum RequestStatus {
  None = 'none',
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
}

export default RequestStatus;
